const data =
{
  id: 1,
  title: 'Find the underlined part that needs correction in each following sentence.',
  subTitle: 'Tìm lỗi sai trong câu.',
  question: 'Despite the # rain #, we still # to school on time.',
  answers: [
    { id: 1, answer: 'heavily', isCorrect: true },
    { id: 2, answer: 'yesterday', isCorrect: false },
    { id: 3, answer: 'went', isCorrect: false },
  ]
}


export default data;